import Tracker from "./Tracker";
import {createUnknownErrorObject, ErrorObject} from "./utils/createUnknownErrorObject";
import {queryString} from "@securionpay-internal/commons-js";
import {callWithIdempotentRetry, HttpCaller} from "./retry";

const ONE_SECOND_IN_MILLIS = 1000;
const createAbortSignal = (timeoutMs: number) => {
    if (timeoutMs) {
        const abortController = new AbortController();
        setTimeout(() => {
            abortController.abort();
        }, timeoutMs <= 1 ? ONE_SECOND_IN_MILLIS : timeoutMs );
        return abortController.signal;
    }
}

const get: HttpCaller<undefined> = (url: URL | RequestInfo, _request: undefined, timeoutMs: number, tracker?: Tracker) => {
    return fetch(
        url,
        {
            method: "GET",
            signal: createAbortSignal(timeoutMs),
        }
    ).catch((e) => {
        const error = createUnknownErrorObject("gateway_error");
        if (tracker) {
            tracker.trackException("fetch.get.error", e, {url, error})
        }
        return {error}
    });
};

const post: HttpCaller<any> = (url: URL | RequestInfo, request: any, timeoutMs: number, tracker?: Tracker) => {
    return fetch(
        url,
        {
            method: "POST",
            body: queryString.stringify(request),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            signal: createAbortSignal(timeoutMs),
        }
    ).catch((e) => {
        const error = createUnknownErrorObject("gateway_error");
        if (tracker) {
            tracker.trackException("fetch.post.error", e, {url, error})
        }
        return {error}
    });
};

const unwrapBody = (response: Response | { error: ErrorObject }) => {
    if (response instanceof Response) {
        return response.json();
    }
    return response;
}

export default {
    getWithRetries: async (url: RequestInfo | URL, tracker?: Tracker, timeoutMs?: number) => {
        const response = await callWithIdempotentRetry(url, get, 'http.get', undefined, tracker, timeoutMs);
        return unwrapBody(response);
    },
    postWithRetries: async (url: RequestInfo | URL, request: any, tracker?: Tracker, timeoutMs?: number) => {
        const response = await callWithIdempotentRetry(url, post, 'http.post', request, tracker, timeoutMs);
        return unwrapBody(response);
    }
}